export interface OfferPriceDateSource {
  expiryDate?: string | Date | null;
  dueDate?: string | Date | null;
}

function toDate(value: string | Date | null | undefined): Date | null {
  if (value == null || value === '') {
    return null;
  }
  if (value instanceof Date) {
    return Number.isNaN(value.getTime()) ? null : value;
  }
  const parsed = new Date(value);
  return Number.isNaN(parsed.getTime()) ? null : parsed;
}

/**
 * Offer-price documents store business expiry in `expiryDate`.
 * `dueDate` is often mirrored from `documentDate` in payloads and must not be used as primary.
 */
export function resolveOfferPriceExpiryDate(
  source: OfferPriceDateSource,
): Date | null {
  return toDate(source.expiryDate) ?? toDate(source.dueDate);
}
